import { render, staticRenderFns } from "./EditCallQueue.vue?vue&type=template&id=3c4f109c&scoped=true&"
import script from "./EditCallQueue.vue?vue&type=script&lang=js&"
export * from "./EditCallQueue.vue?vue&type=script&lang=js&"
import style0 from "./EditCallQueue.vue?vue&type=style&index=0&id=3c4f109c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f109c",
  null
  
)

export default component.exports